function Home()
{
    return(
        <div className="container">
            <h4>Peer Group Reporting</h4>
            <p>Welcome to the new and improved Peer Group Reporting system from Maxim Consulting.</p>
            <img src={"maximlogo.png"} alt="Maxim Consulting Logo"></img>
        </div>
    );
}

export default Home;